function hasSectionContent(section) {
  return section.name !== "" || Object.keys(section.fields || {}).length > 0;
}

function normalizeSection(section) {
  return {
    section_name: section.key,
    key_values: section.fields,
  };
}

export function normalizeV2ApplicationData(data) {
  return {
    sections: (data.sections || [])
      .filter(hasSectionContent)
      .map(normalizeSection),
  };
}
